// extracted by mini-css-extract-plugin
export var compactFilters = "_c3-4";
export var detailImage = "_c3-1";
export var dropdownContainer = "_c3-2";
export var imageContainer = "_c3-0";
export var selectedCard = "_c3-3";